import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { projetosPath, contratosRoute } from '../../library/Routes';
import { PUFVOperacionalPermissions } from '../../store/modules/permissions/PUFVOperacional';

class Main extends Component {
  componentDidMount() {
    let path;
    switch (this.props.auth.userPermissions.id) {
      case PUFVOperacionalPermissions.id:
        path = contratosRoute.path;
        break;
      default:
        path = projetosPath;
    }
    this.props.history.push(path);
  }

  render() {
    return <></>;
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  auth: state.auth,
});

export default connect(mapStateToProps)(withRouter(Main));
